export const STATES = ['AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC',
  'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH',
  'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC',
  'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT',
  'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY'];

export const MIN_YEAR = 2010;
export const MAX_YEAR = (new Date().getFullYear()) + 1;

export const YEAR_LIST = (condition: 'new' | 'used' | 'all' = 'all') => {
  let startYear = MAX_YEAR;
  const yearList = [];

  if (condition === 'new') {
    return [new Date().getFullYear(), (new Date().getFullYear()) + 1];
  } else if (condition === 'used') {
    // Get the years from a year from next year - 2 to 2010
    startYear = startYear - 2;
    while (startYear >= MIN_YEAR) {
      yearList.push(startYear--);
    }
  }

  // Get the years from a year from now + 1 to 2010
  while (startYear >= MIN_YEAR) {
    yearList.push(startYear--);
  }
  return yearList;
};
